// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__196l3","noInteraction":"EventWrapper_noInteraction__25yPv"};